export default __webpack_public_path__ + "static/media/product_card4_Hk.8119adf8.webp";